import React from 'react'
import { createGlobalStyle } from 'styled-components'
import { request } from 'graphql-request'
import { injectStripe } from 'react-stripe-elements'
import { trackEvent } from '../../../lib/tracker'
import permissionsGraphqlMutation from '../../../lib/permission/graphql-mutation'
import ReserveFormComponent from './components/ReserveForm'

const GlobalStyles = createGlobalStyle`
  body {
    top: auto !important;
    bottom: auto !important;
  }
`

const submitForm = (data) => {
  const mutation = `mutation {
    createReservation(reservationRequest: {
      firstName: "${data.firstName}",
      lastName: "${data.lastName}",
      phone: "${data.phone}",
      email: "${data.email}",
      postcode: "${data.postcode}",
      vehicleId: "${data.vehicleId}"
      sourceUrl: "${document.location.toString()}"
      ${permissionsGraphqlMutation()(data)}
    }, paymentMethodId: "${data.paymentMethodId}", paymentId: "${
    data.paymentId
  }") {
      createdDate
      paymentResult {
        requiresAction
        paymentIntentClientSecret
      }
    }
  }`
  return request(`${process.env.GATSBY_API_URL}/graphql`, mutation)
}

class ReserveForm extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      success: false,
      error: false,
      errors: null,
      submittingForm: false
    }
    this.handleSubmit = this.handleSubmit.bind(this)
    this.handleReserveSuccess = this.props.handleReserveSuccess
  }

  async handleSubmit(formData) {
    this.setState({ submittingForm: true })
    const handleSuccess = () => {
      this.setState({ success: true, submittingForm: false })
      this.handleReserveSuccess()
    }
    const handlePayment = async (extraData) => {
      const response = await submitForm({
        ...formData,
        ...extraData,
        vehicleId: this.props.vehicleId
      })
      if (response && response.createReservation) {
        const reservation = response.createReservation

        if (
          reservation.paymentResult &&
          reservation.paymentResult.requiresAction
        ) {
          const cardAction = await this.props.stripe.handleCardAction(
            reservation.paymentResult.paymentIntentClientSecret
          )
          if (cardAction.error) throw new Error(cardAction.error)
          handlePayment({
            paymentId: cardAction.paymentIntent.id
          })
        } else {
          handleSuccess()
        }
      } else {
        this.setState({ error: { message: 'Whoops!' }, submittingForm: false })
      }
    }
    trackEvent('Reserve', 'Form', 'Submit', '', {
      vehicleId: this.props.vehicleId,
      make: this.props.brand,
      model: this.props.model,
      location:
        this.props.location &&
        this.props.location.locationInfo &&
        this.props.location.locationInfo.location
    })
    let stripeResponse
    stripeResponse = await this.props.stripe.createPaymentMethod('card')
    const { error, paymentMethod } = stripeResponse
    if (error) {
      return this.setState({ error, submittingForm: false })
    }
    try {
      await handlePayment({ paymentMethodId: paymentMethod.id })
    } catch (error) {
      trackEvent('Reserve', 'Form', 'Error')
      const errorResponse = error.response && error.response.errors[0]
      this.setState({
        error: {
          message: errorResponse
            ? errorResponse.message
            : 'Please try again later'
        },
        submittingForm: false
      })
    }
  }

  render() {
    return (
      <>
        <GlobalStyles />
        <ReserveFormComponent
          success={this.state.success}
          onSubmit={this.handleSubmit}
          submitting={this.state.submittingForm}
          showStripe
          error={this.state.error}
        />
      </>
    )
  }
}

export default injectStripe(ReserveForm)
